import { ILanguage } from '../../interface';

const es: ILanguage = {
  locale: 'es',
  translations: {
    notifications: 'Notificaciones',
    markAllAsRead: 'Marcar todo como leído',
    noNotificationsTitle: 'Aún no hay notificaciones',
    noNotificationsDescription:
      'Te avisaremos cuando tengamos algo nuevo para ti.',
    pinned: 'Fijado',
    markAsUnread: 'Marcar como no leído',
    markAsRead: 'Marcar como leído',
    archive: 'Archivo',
    expiresIn: 'Vence en',
    minute: 'minuto',
    minutes: 'minutos',
    hour: 'hora',
    hours: 'horas',
    day: 'día',
    days: 'días',
    week: 'semana',
    weeks: 'semanas',
    month: 'mes',
    months: 'meses',
    year: 'año',
    years: 'años',
  },
};

export default es;
